module.exports = __webpack_public_path__ + "static/media/p4.86f7278d.png";